import gql from 'graphql-tag';

export const avatarFragment = gql`
  fragment AvatarFragment on User {
    avatarV2 {
      type
      value
    }
  }
`;
